import { createSlice } from "@reduxjs/toolkit";

export interface LeadsManagementSlice {
  items: any[];
  selected: Record<string, boolean>;
  // Brand Match diagnostic — keyed by leadId (string) for the current session.
  // Result shape is whatever the BQL query returns; not yet mapped/typed
  // since the endpoint's response structure isn't confirmed working.
  brandMatchCache: Record<string, any>;
  brandMatchLoading: Record<string, boolean>;
  brandMatchError: Record<string, string | null>;
}

const initialState: LeadsManagementSlice = {
  items: [],
  selected: {},
  brandMatchCache: {},
  brandMatchLoading: {},
  brandMatchError: {},
};

const leadsManagementSlice = createSlice({
  name: "leadsManagement",
  initialState,
  reducers: {
    setItems: (state, action) => {
      state.items = action.payload;
    },
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    clearSelected: (state) => {
      state.selected = {};
    },
    setBrandMatchLoading: (
      state,
      action: { payload: { leadId: string; loading: boolean } },
    ) => {
      state.brandMatchLoading[action.payload.leadId] = action.payload.loading;
    },
    setBrandMatchResult: (
      state,
      action: { payload: { leadId: string; data: any } },
    ) => {
      state.brandMatchCache[action.payload.leadId] = action.payload.data;
    },
    setBrandMatchError: (
      state,
      action: { payload: { leadId: string; error: string | null } },
    ) => {
      state.brandMatchError[action.payload.leadId] = action.payload.error;
    },
  },
});

export const {
  setItems,
  setSelected,
  clearSelected,
  setBrandMatchLoading,
  setBrandMatchResult,
  setBrandMatchError,
} = leadsManagementSlice.actions;

export const selectBrandMatchCache = (state: any) =>
  state.leadsManagement.brandMatchCache;
export const selectBrandMatchLoading = (state: any) =>
  state.leadsManagement.brandMatchLoading;
export const selectBrandMatchError = (state: any) =>
  state.leadsManagement.brandMatchError;

export default leadsManagementSlice.reducer;
